import React, { useEffect } from 'react';
import { Container, Row, Col, Card, Nav } from 'react-bootstrap';
import { NavLink, useHistory } from 'react-router-dom';
import { connect } from 'react-redux';
import { Helmet } from 'react-helmet-async';

const AdminToolsLayout = ({ auth, children }) => {
  const history = useHistory();

  useEffect(() => {
    if (auth === null || auth === undefined) return;
    if (auth === false) {
      history.push('/');
      return;
    }
    if (!auth.id || auth.role !== 'admin') {
      history.push('/');
    }
  }, [auth, history]);

  if (!auth || auth.role !== 'admin') {
    return null;
  }

  return (
    <>
      <Helmet>
        <title>Article to Media Admin | Elliot Koss</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      <Container style={{ paddingTop: '100px', paddingBottom: '2rem' }}>
        <Row className="mb-4">
          <Col>
            <h1>Article to Media Admin</h1>
            <p className="text-muted">Manage access codes, settings, and monitor usage</p>
          </Col>
        </Row>

        <Row>
          <Col md={3} className="mb-4">
            <Card>
              <Card.Body className="p-0">
                <Nav variant="pills" className="flex-column">
                  <Nav.Item>
                    <Nav.Link as={NavLink} to="/admin/tools/access-codes" exact>
                      Access Codes
                    </Nav.Link>
                  </Nav.Item>
                  <Nav.Item>
                    <Nav.Link as={NavLink} to="/admin/tools/spend-report" exact>
                      Spend Report
                    </Nav.Link>
                  </Nav.Item>
                  <Nav.Item>
                    <Nav.Link as={NavLink} to="/admin/tools/settings" exact>
                      Settings
                    </Nav.Link>
                  </Nav.Item>
                  <Nav.Item>
                    <Nav.Link as={NavLink} to="/admin/tools/prompts" exact>
                      Prompts
                    </Nav.Link>
                  </Nav.Item>
                  <Nav.Item>
                    <Nav.Link as={NavLink} to="/admin/tools/articles" exact>
                      Articles
                    </Nav.Link>
                  </Nav.Item>
                  <Nav.Item>
                    <Nav.Link as={NavLink} to="/admin/tools/allowlist" exact>
                      Allowlist
                    </Nav.Link>
                  </Nav.Item>
                  <Nav.Item>
                    <Nav.Link as={NavLink} to="/admin/tools/blocklist" exact>
                      Blocklist
                    </Nav.Link>
                  </Nav.Item>
                  <Nav.Item>
                    <Nav.Link as={NavLink} to="/admin/tools/analytics" exact>
                      Analytics
                    </Nav.Link>
                  </Nav.Item>
                  <Nav.Item>
                    <Nav.Link as={NavLink} to="/admin/tools/url-log" exact>
                      URL Log
                    </Nav.Link>
                  </Nav.Item>
                  <Nav.Item>
                    <Nav.Link as={NavLink} to="/admin/tools/delete-review" exact>
                      Delete Review
                    </Nav.Link>
                  </Nav.Item>
                </Nav>
              </Card.Body>
            </Card>
          </Col>

          <Col md={9}>
            {children}
          </Col>
        </Row>
      </Container>
    </>
  );
};

function mapStateToProps({ auth }) {
  return { auth };
}

export default connect(mapStateToProps)(AdminToolsLayout);
